import { render } from "./LabelMaterials.vue?vue&type=template&id=1fa8b52c&scoped=true&ts=true"
import script from "./LabelMaterials.vue?vue&type=script&lang=ts"
export * from "./LabelMaterials.vue?vue&type=script&lang=ts"

import "./LabelMaterials.vue?vue&type=style&index=0&id=1fa8b52c&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa8b52c"]])

export default __exports__